import {Injectable, isDevMode} from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {Centre, CentreOption} from 'src/app/interfaces/Centres'
import {Database, increment, ref, set} from "@angular/fire/database";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UnitModel} from "../models/UnitModel";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {catchError, map, shareReplay, tap} from "rxjs/operators";

import {environment} from "../../environments/environment";

import { FormControl } from '@angular/forms';
import {combineLatest, Observable, of, take, throwError} from "rxjs";




/**
 * Head Office is not a real centre document — it has no Firestore record, no
 * units and no ranking. It is injected into the centre list by centresWithHO()
 * so the Inventory module can issue stock to HO departments the same way it
 * issues to a centre's units.
 */
export const HO_CENTRE_CODE = 'HO';

export const HO_CENTRE: Centre = {
  centreCode: HO_CENTRE_CODE,
  centreName: 'Head Office',
  mealMate: false,
  unitSponsorship: false,
  isArchive: false,
};

/** True when a centre code refers to Head Office rather than a real centre. */
export function isHoCentre(centreCode: string | null | undefined): boolean {
  return (centreCode ?? '').trim().toUpperCase() === HO_CENTRE_CODE;
}

@Injectable({
    providedIn: 'root'
})

export class CentreService {
  private centres$: Observable<Centre[]> | null = null;
  private centreRead = 0;
    id = ''
    // unitArray: UnitModel[] = []
    env = isDevMode() ? environment.testMode : environment.productionMode
centreControl = new FormControl()
    constructor(private mDatabase: AngularFireDatabase,
                private mDatabaseRef: Database,
                private mFirestore: AngularFirestore,
                private _snackbar: MatSnackBar) {
        // console.log(isDevMode())
    }

  getCenterByCode(centerCode: string): Observable<Centre | undefined> {
    return this.mFirestore
      .collection<Centre>(this.env.centres, ref => ref.where('centreCode', '==', centerCode))
      .valueChanges({ idField: 'id' })
      .pipe(map(centres => centres[0]), shareReplay(1));
  }

  getChildrenByCentre(centreCode: string): Observable<any[]> {
    return this.mFirestore.collection(
      this.env.child,
      ref => ref.where('centreCode', '==', centreCode)
    ).valueChanges({ idField: 'id' }).pipe(take(1), shareReplay(1));
  }

  // addCenter2(centre: Centre, unitArr: Array<UnitModel>) {
  //       //* GETTING LATEST CENTER NUMBER FROM CENTRE COUNTER FROM FIREBASE DATABASE
  //       const mCounterRef = this.mDatabase.object(`${this.env.counters}/centreCounter`)
  //       let sub$ = mCounterRef.valueChanges().subscribe((res) => {
  //           // console.log(res)
  //
  //           //**  This is the new Id by which center will be added*/
  //           const newId = centre.centreName.replace(' ', '')
  //           this.id = newId
  //           console.log(newId)
  //           centre.sr = res as number
  //           //**  We are adding the centre with new generated Center ID  */
  //           centre.centreCode = newId
  //           this.mFirestore.doc(`${this.env.centres}/${newId}`).set(centre)
  //           this.mDatabase.object(`${this.env.centres}/${newId}`).set(centre).then(() => {
  //               sub$.unsubscribe()
  //               const documentRef = ref(this.mDatabaseRef, `${this.env.counters}/centreCounter`)
  //               /**After adding increasing the current center counter by 1 */
  //               set(documentRef, increment(1)).then(() => {
  //                   // Array to Unit Logic
  //                   //
  //                   let map = new Map<string, UnitModel>()
  //                   for (let i = 0; i < Number(unitArr.length); i++) {
  //                       // console.log(`repeated ${i} times`)
  //                       // const a = new UnitModel()
  //                       // @ts-ignore
  //                       unitArr.at(i).order = i + 1
  //                       // @ts-ignore
  //                       unitArr.at(i).centreName = centre.centreName
  //
  //                       // @ts-ignore
  //                       unitArr.at(i).centreCode = newId
  //                       // @ts-ignore
  //                       map.set(`${newId}-${i + 1}`, unitArr.at(i) as UnitModel)
  //                       console.log(map.get(`${newId}-${i + 1}`))
  //                       // this.unitArray.set('AL',a)
  //                       // console.log('unitarray: ', map)
  //                   }
  //                   // console.log('after loop', map)
  //
  //                   map.forEach((i, key) => {
  //                       i.key = key
  //                       this.mDatabase.object(`${this.env.units}/${this.id}/${key}`).update(i)
  //                       console.log('Key:' + key, 'value ' + i.key)
  //                   })
  //                   this.mDatabase.object(`${this.env.units}/test`).set(map).then(() => {
  //                       this._snackbar.open('Center Added Successfully!', '', {duration: 2000})
  //                   }).catch((reason) => {
  //                       console.log(reason)
  //                   })
  //
  //                   //   console.log('counter updated by 1')
  //                   // })
  //               })
  //
  //
  //               // this.mDatabase.object('counters/centreCounter',{})
  //               // @ts-ignore
  //               //Getting Current Counter From Database
  //               // get(documentRef).then((snapshot)=>{
  //               //   console.log(snapshot.val())
  //               // })
  //               // return set(documentRef, increment(1)).then(() => {
  //               //   console.log('counter updated by 1')
  //               // })
  //
  //           })
  //       })
  //   }


addCenter2(centre: Centre, unitArr: Array<UnitModel>) {

  const mCounterRef = this.mDatabase.object(`${this.env.counters}/centreCounter`)

  mCounterRef.valueChanges().pipe(take(1)).subscribe(async (res) => {

    const newId = centre.centreName.replace(/\s+/g, '')
    this.id = newId

    //  Default Fields
    centre.isArchive = false
    centre.totalRanking = 0
    centre.sr = res as number
    centre.centreCode = newId

    try {
      // 1. SAVE CENTRE
      await this.mFirestore.doc(`${this.env.centres}/${newId}`).set(centre)
      await this.mDatabase.object(`${this.env.centres}/${newId}`).set(centre)

      // 2. INCREMENT COUNTER

      const documentRef = ref(this.mDatabaseRef, `${this.env.counters}/centreCounter`)
      await set(documentRef, increment(1))

      //  3. UNITS -> Firestore batch ({env.units}/{centre}/units/{key})

      const unitBatch = this.mFirestore.firestore.batch()

      unitArr.forEach((unit, i) => {
        const key = `${newId}-${i + 1}`

        unit.order = i + 1
        unit.centreName = centre.centreName
        unit.centreCode = newId
        unit.key = key

        // plain object: Firestore rejects class instances
        unitBatch.set(
          this.mFirestore.firestore.doc(`${this.env.units}/${newId}/units/${key}`),
          JSON.parse(JSON.stringify(unit))
        )
      })
      await unitBatch.commit()

      const updates: any = {}

      // 4. GET USERS ONCE (NO snapshotChanges)

      const usersSnap = await this.mDatabase.database
        .ref(this.env.users)
        .once('value')

      const users = usersSnap.val() || {}

      const allowedRoles = ['Super Admin', 'Lead Counsellor', 'Lead Teacher']

      Object.keys(users).forEach(userKey => {
        const userData = users[userKey]

        if (allowedRoles.includes(userData.role)) {

          let centresAllowed = userData.centresAllowed || []

          if (!centresAllowed.includes(newId)) {
            centresAllowed.push(newId)

            // Add to batch update
            updates[`${this.env.users}/${userKey}/centresAllowed`] = centresAllowed
          }
        }
      })

      //  5. USERS UPDATE (Realtime DB)

      await this.mDatabase.database.ref().update(updates)

      // SUCCESS

      this._snackbar.open('Center Added Successfully!', '', { duration: 2000 })

    } catch (error) {
      console.error('Error:', error)
    }

  })
}

    updateCenter(key: String, centre: Centre, oldUnits: number, newUnits: number) {
        // console.log('EDIT CENTRE', centre)

        this.allotNewUnits(centre, oldUnits, newUnits)
        // centre.availableUnits = centre.totalUnits-centre.occupiedUnits!
        return this.mFirestore.doc(`${this.env.centres}/${centre.centreCode}`).update(centre)

        // return this.mDatabase.object(`dummy/centrelist/${key}`).update(centre)
    }

    allotNewUnits(centre: Centre, oldUnits: number, newUnits: number) {
        if (newUnits > oldUnits) {
            const map = new Map<string, UnitModel>()
            for (let i = 0; i < Number(centre.totalUnits); i++) {
                //     console.log(`repeated ${i} times`)
                const a = new UnitModel()
                a.centreName = centre.centreName
                a.order = i + 1
                a.centreCode = centre.centreCode

                if (i >= oldUnits) map.set(`${a.centreCode}-${i + 1}`, a)
            }
            // console.log('after loop', map)

            const batch = this.mFirestore.firestore.batch()
            map.forEach((i, key) => {
                i.key = key
                batch.set(
                    this.mFirestore.firestore.doc(`${this.env.units}/${centre.centreCode}/units/${key}`),
                    JSON.parse(JSON.stringify(i))
                )
            })
            batch.commit().catch(err => console.error('Failed to create new units', err))
        }
    }

    getAllCentresBackup() {
        let userData = JSON.parse(localStorage.getItem('userData')!)
        let query = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('isArchive','!=',true)).valueChanges({idField: 'key'})
        if (userData.role == 'Centre') query = this.getSortedCenterListByRole(userData.centreCode)
        return query.pipe(shareReplay(1))
    }
    getAllCentres() {
        let userData = JSON.parse(localStorage.getItem('userData')!)
        let query = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('isArchive','!=',true)).valueChanges({idField: 'key'})
        // Super Admin always sees every centre — a stale/incomplete centresAllowed list on the
        // account record must never hide newly added centres from the one role that needs all of them.
        if (userData.centresAllowed && userData.role !== 'Super Admin') query = this.getCentresByArray(userData.centresAllowed)
        return query.pipe(
            map(centres => [...centres].sort((a, b) => (a.centreName || '').localeCompare(b.centreName || ''))),
            shareReplay(1)
        )
    }


  /**
   * Centre list for the Inventory module, with Head Office prepended.
   *
   * HO is synthetic — see HO_CENTRE. Selecting it means "issue to a department"
   * rather than "issue to a unit"; callers branch on isHoCentre(centreCode).
   * Use this instead of getAllCentres() only on inventory screens where issuing
   * to HO is meaningful.
   */
  centresWithHO(): Observable<Centre[]> {
    return this.getAllCentres().pipe(
      map(centres => [HO_CENTRE, ...centres]),
      shareReplay(1)
    );
  }

  /** Departments available as an HO issue destination. Sourced from Employees. */
  getDepartments(): Observable<string[]> {
    return this.mDatabase.list<string>('types/Employee Departments').valueChanges().pipe(
      map(departments => [...(departments || [])].sort((a, b) => (a || '').localeCompare(b || ''))),
      shareReplay(1)
    );
  }

  getAllCentresBorivali() {
    return this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('centreCode','==','ALBorivali')).valueChanges({idField: 'key'}).pipe(shareReplay(1))
  }
    getAllCentresForMealmate() {
        return this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('isArchive','!=',true).where('mealMate','==',true)).valueChanges({idField: 'key'}).pipe(shareReplay(1))
    }
    getAllCentresOptions() {
        let userData = JSON.parse(localStorage.getItem('userData')!)
        let query = this.mFirestore.collection<CentreOption>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('isArchive','!=',true)).valueChanges({idField: 'key'})
        if (userData.centresAllowed && userData.role !== 'Super Admin') query = this.getCentresByArray(userData.centresAllowed)
        return query.pipe(
            map(centres => centres.map<CentreOption>(centre => ({ centreName: centre.centreName, centreCode: centre.centreCode }))),
            map(options => [...options].sort((a, b) => (a.centreName || '').localeCompare(b.centreName || ''))),
            shareReplay(1)
        )
    }
//* Used in unit sponsorship
  getAllCentresSorting(centreCode:string) {
    let userData = JSON.parse(localStorage.getItem('userData')!)
    let query = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('isArchive','!=',true)).valueChanges({idField: 'key'})
    if (centreCode != 'All') query = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy('isArchive','asc').where('isArchive','!=',true).where('centreCode','==',centreCode)).valueChanges({idField: 'key'})
    if (userData.centresAllowed && userData.role !== 'Super Admin') query = this.getCentresByArray(userData.centresAllowed)
    return query.pipe(shareReplay(1))
  }

    // getCentresByArray(centresAllowed: string[]) {
    //     const centerRef = this.mFirestore.collection<Centre>(this.env.centres, ref1 =>
    //         ref1
    //             .where('centreCode', 'in', centresAllowed)
    //             .where('isArchive', '!=', true)
    //             // .orderBy("sr", 'desc') // Use only if necessary
    //             // .limit(20) // Example: Limit results to 20
    //     );
    //
    //     return centerRef.valueChanges({ idField: 'key' }).pipe(
    //         tap(arr => console.log(`centre: read (${this.centreRead += arr.length}) docs`)),
    //         shareReplay(1),
    //         catchError(error => {
    //             // Handle errors gracefully
    //             console.error('Error fetching centres:', error);
    //             return throwError(error);
    //         })
    //     );
    // }
  getCentresByArray(centresAllowed: string[]) {
    if (!centresAllowed || centresAllowed.length === 0) {
      return of([]); // No centres allowed
    }

    const chunkSize = 10;
    const chunks = Array.from({ length: Math.ceil(centresAllowed.length / chunkSize) }, (_, i) =>
      centresAllowed.slice(i * chunkSize, i * chunkSize + chunkSize)
    );

    const queries = chunks.map(chunk =>
      this.mFirestore.collection<Centre>(this.env.centres, ref1 =>
        ref1
          .where('centreCode', 'in', chunk)
          .where('isArchive', '!=', true)
      ).valueChanges({ idField: 'key' })
    );

    return combineLatest(queries).pipe(
      map(results => results.flat()), // merge chunk results
      map(centres => [...centres].sort((a, b) => (a.centreName || '').localeCompare(b.centreName || ''))),
      tap(arr => console.log(`centre: read (${this.centreRead += arr.length}) docs`)),
      shareReplay(1),
      catchError(error => {
        console.error('Error fetching centres:', error);
        return throwError(error);
      })
    );
  }
    getTotalAllCentres() {
        return this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy("isArchive").orderBy('sr', 'desc').where('isArchive',"!=",true)).valueChanges().pipe(shareReplay(1))
    }
    getCentreByCode(centreCode:string) {
        let userData = JSON.parse(localStorage.getItem('userData')!)
        let query = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.where('centreCode','==',centreCode)).valueChanges({idField: 'key'})
        if (userData.role == 'Centre') query = this.getSortedCenterListByRole(userData.centreCode)
        return query.pipe(shareReplay(1))
    }
 //? FETCHING ALL ACTIVE AND INACTIVE CENTRES
  getCentreList() {
    // If we already have the observable, return it instead of hitting Firestore again
    if (!this.centres$) {
      const centreRef = this.mFirestore.collection<Centre>(this.env.centres);

      this.centres$ = centreRef.valueChanges().pipe(
        tap(arr => {
          this.centreRead += arr.length;
          console.log(`centre: read (${this.centreRead}) docs`);
        }),
        shareReplay(1) // Correctly placed as its own operator
      );
    }
    return this.centres$;
  }

  // 1. Corrected Sorted List (Fixed parentheses)
  getSortedCenterList() {
    const centerRef = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy("sr", 'desc'));
    return centerRef.valueChanges({idField: 'key'}).pipe(
      tap(arr => console.log(`centre: read (${this.centreRead += arr.length}) docs`)),
      shareReplay(1) // Moved outside tap
    );
  }

// 2. Corrected Role Based List
  getSortedCenterListByRole(centreCode: string) {
    const centerRef = this.mFirestore.collection<Centre>(this.env.centres, ref1 =>
      ref1.where('centreCode', '==', centreCode)
    );
    return centerRef.valueChanges({idField: 'key'}).pipe(
      tap(arr => console.log(`centre: read (${this.centreRead += arr.length}) docs`)),
      shareReplay(1) // Moved outside tap
    );
  }

    getCentreListSnapshot() {
        const centreRef = this.mDatabase.list<Centre>(`${this.env.centres}/centrelist`)
        return centreRef.snapshotChanges()
    }

    archiveCenter(c: Centre) {
        let value = c.isArchive
        if (c.isArchive == true) {
            value = false
        } else value = true
        return this.mFirestore.doc(`${this.env.centres}/${c.centreCode}`).update({isArchive: value})

    }

    getAmmenities() {
        return this.mDatabase.list('types/Ammenities').valueChanges()
    }

    getCentresByRole() {

        const centerRef = this.mFirestore.collection<Centre>(this.env.centres, ref1 => ref1.orderBy("sr", 'desc'))

        return centerRef.valueChanges({idField: 'key'}).pipe(
            tap(arr => console.log(`centre: read (${this.centreRead += arr.length}) docs`)),
            shareReplay(1)
        )
    }
// 3. Consolidated Single Centre Fetch
  fetchCentreByCode(centreCode: string) {
    // This is good for a one-time fetch (Promise)
    return this.mFirestore.collection(this.env.centres).doc(centreCode).get().toPromise();
  }

}
